import { useAlphabet } from "../../Project/ProjectStore"
import { Music } from "./Music"

export class Chords{
    static TypeDiminished:string = 'Dim.'
    static TypeMajor:string = 'Major'
    static TypeMinor:string = 'Minor'
    static GetChordType = (chordNumber:number) => {
        if([0,3,4].includes(chordNumber)) return Chords.TypeMajor
        if([1,2,5].includes(chordNumber)) return Chords.TypeMinor
        return Chords.TypeDiminished
    }
    static Formula_triad:number[] = [0,2,4]
    static Formula_sixth:number[] = [0,2,4,5]
    static Formula_seventh:number[] = [0,2,4,6]
    static Formula_sus2:number[] = [0,1,4]
    static Formula_sus4:number[] = [0,3,4]
    static GetChordNoteTonics = (keyTonic:number, chordNumber:number, chordFormula:number[] = Chords.Formula_triad) => {
        const keyNotes:number[] = Music.getKeyScale(keyTonic)
        const positions:number[] = Chords.GetChordPositions(chordNumber, chordFormula)
        let notes:number[] = positions.map((position:number)=>{
            return keyNotes[position]
        })
        return notes
    }
    static GetChordPositions = (chordNumber:number, chordFormula:number[] = Chords.Formula_triad) => {
        let positions:number[] = chordFormula.map((interval:number)=>{
            return (chordNumber + interval) % 7
        })
        return positions
    }
}

export function useChordNoteNames(keyTonic:number, chordNumber:number, chordFormula:number[] = [0,2,4]){
    const noteNames:string[] = useAlphabet()
    const notes:number[] = Chords.GetChordNoteTonics(keyTonic, chordNumber, chordFormula)
    let chordNoteNames:string[] = notes.map((note:number)=>{ return noteNames[note] })
    return chordNoteNames
}